export const COMPANY = {
  name: "Kruška Distribucija DOO",
  short: "Kruška Distribucija",
  siteUrl: "https://kruska-food-dist.preview.emergentagent.com",
  address: "Savska 40, 37000 Kruševac, Srbija",
  phone: "065 / 3333 670",
  phoneHref: "+381653333670",
  phone2: "063 / 494 340",
  phone2Href: "+38163494340",
  email: "kruskadistribucija@gmail.com",
  pib: "114091524",
  mb: "21970018",
  mapsUrl: "https://maps.app.goo.gl/APzSTaGzpFCSNhFH9",
  mapEmbed:
    "https://www.google.com/maps?q=43.590927,21.3543578&z=17&output=embed",
  hours: {
    sr: [
      { d: "Ponedeljak – Petak", h: "08:00 – 16:00" },
      { d: "Subota", h: "Ne radimo" },
      { d: "Nedelja", h: "Ne radimo" },
    ],
    en: [
      { d: "Monday – Friday", h: "8:00 AM – 4:00 PM" },
      { d: "Saturday", h: "Closed" },
      { d: "Sunday", h: "Closed" },
    ],
  },
  logo:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_6a35d6c6-f819-4b71-9ceb-4a4799252ddb/artifacts/azbkx405_logo.png",
  catalogPdf:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/nnf2jwsh_Katalog_2026_distribucija.pdf",
  photos: {
    exterior:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/1gx52lgh_prostor%20ispred.jpg",
    warehouseRoom:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/wey2ske7_ChatGPT%20Image%20Jul%2030%2C%202026%2C%2005_15_59%20PM.png",
    shelves:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/y96xzakm_11a32ec8-f74b-4137-910c-164ca97a4351.png",
    aisle:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/xuavol6q_4c0367c4-570b-4c6a-8eab-83c4d1703a71.png",
    milka:
      "https://customer-assets-lxgj4vgw.emergentagent.net/job_kruska-food-dist/artifacts/9apzz4j9_0f14911d-2d05-4a93-afdf-edd54d8f27e0.png",
  },
};

export const translations = {
  sr: {
    nav: {
      about: "O nama",
      categories: "Asortiman",
      supply: "Kupci",
      offers: "Ponude",
      contact: "Kontakt",
      catalog: "Katalog",
      inquiry: "Pošalji upit",
    },
    hero: {
      badge: "Veleprodaja · Distribucija · Srbija",
      line1: "Pouzdan partner",
      line2: "za vaše police.",
      lead:
        "Kruška Distribucija je veleprodajni distributer prehrambenih proizvoda, pića, konditorskog programa i robe široke potrošnje širom Srbije.",
      ctaPrimary: "Zatražite ponudu",
      ctaSecondary: "Pogledajte asortiman",
      stat1: "9", stat1l: "kategorija robe",
      stat2: "500+", stat2l: "artikala u ponudi",
      stat3: "B2B", stat3l: "isključivo pravna lica",
    },
    manifesto: {
      overline: "Zašto Kruška",
      title: "Ozbiljan distributer za ozbiljne kupce.",
      chapters: [
        { n: "01", t: "Pouzdanost", d: "Redovno snabdevanje i stabilne isporuke na koje vaš objekat može da računa svakog dana." },
        { n: "02", t: "Širok asortiman", d: "Od svetskih brendova do domaćeg programa — sve na jednom mestu, na jednoj fakturi." },
        { n: "03", t: "Konkurentne cene", d: "Veleprodajni uslovi prilagođeni obimu vaše nabavke i tipu objekta." },
        { n: "04", t: "Brza komunikacija", d: "Direktan kontakt sa komercijalom i brz odgovor na svaki upit ili ponudu." },
      ],
    },
    categories: {
      overline: "Asortiman",
      title: "Sve kategorije robe široke potrošnje.",
      lead: "Kompletan program za markete, kioske, ugostiteljstvo i benzinske stanice.",
      view: "Pogledaj proizvode",
      cta: "Otvori kompletan katalog",
    },
    supply: {
      overline: "Kome isporučujemo",
      title: "Snabdevamo poslovne kupce širom Srbije.",
      lead: "Kruška Distribucija posluje isključivo sa pravnim licima i preduzetnicima.",
      items: [
        "Samostalni marketi i mini-marketi",
        "Trgovinski lanci i nabavne službe",
        "Kiosci i trafike",
        "Benzinske stanice",
        "Ugostiteljski objekti (HoReCa)",
        "Hoteli i restorani",
        "Distributeri i veleprodaje",
        "Ostali maloprodajni kupci",
      ],
    },
    gallery: {
      overline: "Naš prostor",
      title: "Autentičan pogled na našu firmu.",
      lead: "Poslovni prostor, magacin i asortiman spremni za brzu isporuku — sve fotografije su iz naše firme.",
      captions: {
        exterior: "Poslovni objekat",
        aisle: "Magacinski prostor",
        shelves: "Rafovi sa asortimanom",
        milka: "Konditorski program",
        warehouseRoom: "Roba na lageru",
      },
    },
    offers: {
      overline: "Aktuelno",
      title: "Akcije, noviteti i veleprodajne ponude.",
      lead: "Pratite posebne uslove i sezonske ponude za naše partnere.",
      cards: [
        { tag: "Akcija", t: "Konditorski program", d: "Posebni veleprodajni uslovi na Milka i Mars asortiman za veće količine." },
        { tag: "Novo", t: "Energetska pića", d: "Prošireni asortiman energetskih pića — idealno za kioske i pumpe." },
        { tag: "Sezonski", t: "Kafa program", d: "Grand i Nescafé po specijalnim cenama za ugostiteljstvo." },
      ],
    },
    inquiry: {
      overline: "Zahtev za ponudu",
      title: "Pošaljite upit u par klikova.",
      lead: "Popunite formu i naša komercijala vam se javlja sa ponudom prilagođenom vašem objektu.",
      fields: {
        company: "Naziv firme / objekta",
        contact: "Ime i prezime",
        email: "Email",
        phone: "Telefon",
        business: "Tip objekta",
        city: "Grad",
        categories: "Kategorije koje vas zanimaju",
        message: "Poruka / detalji upita",
      },
      businessOptions: ["Market", "Mini-market", "Kiosk", "Benzinska stanica", "Ugostiteljstvo / HoReCa", "Hotel / Restoran", "Distributer", "Ostalo"],
      submit: "Pošalji upit",
      sending: "Slanje...",
      success: "Hvala! Vaš upit je poslat. Javljamo vam se uskoro.",
      error: "Došlo je do greške. Pokušajte ponovo ili nas pozovite.",
      pick: "Izaberite",
    },
    partner: {
      overline: "Veleprodajna saradnja",
      title: "Postanite partner Kruške.",
      lead: "Prijavite se za otvaranje veleprodajnog naloga i saradnju na duge staze.",
      fields: {
        company: "Naziv firme",
        pib: "PIB",
        contact: "Ovlašćeno lice",
        email: "Email",
        phone: "Telefon",
        business: "Tip delatnosti",
        city: "Grad",
        volume: "Očekivani mesečni obim",
        message: "Dodatne napomene",
      },
      submit: "Prijavi saradnju",
      sending: "Slanje...",
      success: "Hvala! Vaša prijava za saradnju je primljena.",
      error: "Došlo je do greške. Pokušajte ponovo.",
    },
    contact: {
      overline: "Kontakt",
      title: "Tu smo za vaš objekat.",
      call: "Pozovite nas",
      write: "Pišite nam",
      visit: "Adresa",
      hours: "Radno vreme",
      hoursVal: "Pon – Pet: 08–16h · Sub/Ned: ne radimo",
      directions: "Navigacija",
    },
    footer: {
      tagline: "Veleprodajna distribucija robe široke potrošnje.",
      company: "Firma",
      legal: "Pravni podaci",
      quick: "Brzi linkovi",
      rights: "Sva prava zadržana.",
      b2b: "Uskoro: B2B portal za poručivanje.",
    },
    common: { required: "obavezno", optional: "opciono" },
    seo: {
      home: {
        title: "Kruška Distribucija DOO — Veleprodaja i distribucija robe široke potrošnje | Kruševac",
        description:
          "Veleprodajni distributer prehrambenih proizvoda, pića, konditorskog programa, grickalica i robe široke potrošnje širom Srbije. Snabdevamo markete, kioske, HoReCa i benzinske stanice. Zatražite ponudu.",
      },
      catalog: {
        title: "Katalog 2026 — Kruška Distribucija | Čokolade, pića, kafa, grickalice",
        description:
          "Kompletan asortiman Kruška Distribucije: Milka, Mars, Kinder, Ferrero, Nutella, Coca-Cola, Red Bull, Grand, Nescafé, Pringles, Orbit, Jack Daniel's i drugi vodeći brendovi. Veleprodajni katalog 2026.",
      },
    },
  },
  en: {
    nav: {
      about: "About",
      categories: "Range",
      supply: "Buyers",
      offers: "Offers",
      contact: "Contact",
      catalog: "Catalogue",
      inquiry: "Send inquiry",
    },
    hero: {
      badge: "Wholesale · Distribution · Serbia",
      line1: "A reliable partner",
      line2: "for your shelves.",
      lead:
        "Kruška Distribucija is a wholesale distributor of food, beverages, confectionery and everyday consumer goods across Serbia.",
      ctaPrimary: "Request a quote",
      ctaSecondary: "Explore the range",
      stat1: "9", stat1l: "product categories",
      stat2: "500+", stat2l: "items in stock",
      stat3: "B2B", stat3l: "businesses only",
    },
    manifesto: {
      overline: "Why Kruška",
      title: "A serious distributor for serious buyers.",
      chapters: [
        { n: "01", t: "Reliability", d: "Consistent supply and stable deliveries your business can count on every single day." },
        { n: "02", t: "Wide range", d: "From global brands to local classics — everything in one place, on a single invoice." },
        { n: "03", t: "Competitive pricing", d: "Wholesale terms tailored to your order volume and type of business." },
        { n: "04", t: "Fast communication", d: "Direct contact with our sales team and a quick response to every inquiry." },
      ],
    },
    categories: {
      overline: "The range",
      title: "Every category of consumer goods.",
      lead: "A complete program for markets, kiosks, HoReCa and gas stations.",
      view: "View products",
      cta: "Open the full catalogue",
    },
    supply: {
      overline: "Who we supply",
      title: "Serving business buyers across Serbia.",
      lead: "Kruška Distribucija works exclusively with companies and entrepreneurs.",
      items: [
        "Independent markets & mini-markets",
        "Retail chains & procurement teams",
        "Kiosks & newsstands",
        "Gas stations",
        "Hospitality venues (HoReCa)",
        "Hotels & restaurants",
        "Distributors & wholesalers",
        "Other retail buyers",
      ],
    },
    gallery: {
      overline: "Our facility",
      title: "An authentic look inside our company.",
      lead: "Offices, warehouse and stock ready for fast delivery — every photo is from our own company.",
      captions: {
        exterior: "Our premises",
        aisle: "Warehouse floor",
        shelves: "Stocked shelves",
        milka: "Confectionery program",
        warehouseRoom: "Goods in stock",
      },
    },
    offers: {
      overline: "What's new",
      title: "Promotions, new arrivals & wholesale deals.",
      lead: "Follow special terms and seasonal offers for our partners.",
      cards: [
        { tag: "Deal", t: "Confectionery", d: "Special wholesale terms on Milka and Mars range for larger quantities." },
        { tag: "New", t: "Energy drinks", d: "Expanded energy drink range — ideal for kiosks and gas stations." },
        { tag: "Seasonal", t: "Coffee program", d: "Grand and Nescafé at special prices for hospitality." },
      ],
    },
    inquiry: {
      overline: "Request for quote",
      title: "Send an inquiry in a few clicks.",
      lead: "Fill in the form and our sales team will reach out with an offer tailored to your business.",
      fields: {
        company: "Company / venue name",
        contact: "Full name",
        email: "Email",
        phone: "Phone",
        business: "Type of business",
        city: "City",
        categories: "Categories of interest",
        message: "Message / inquiry details",
      },
      businessOptions: ["Market", "Mini-market", "Kiosk", "Gas station", "Hospitality / HoReCa", "Hotel / Restaurant", "Distributor", "Other"],
      submit: "Send inquiry",
      sending: "Sending...",
      success: "Thank you! Your inquiry has been sent. We'll be in touch shortly.",
      error: "Something went wrong. Please try again or call us.",
      pick: "Select",
    },
    partner: {
      overline: "Wholesale partnership",
      title: "Become a Kruška partner.",
      lead: "Apply to open a wholesale account and build a long-term partnership.",
      fields: {
        company: "Company name",
        pib: "Tax ID (PIB)",
        contact: "Authorised person",
        email: "Email",
        phone: "Phone",
        business: "Type of business",
        city: "City",
        volume: "Expected monthly volume",
        message: "Additional notes",
      },
      submit: "Apply for partnership",
      sending: "Sending...",
      success: "Thank you! Your partnership application has been received.",
      error: "Something went wrong. Please try again.",
    },
    contact: {
      overline: "Contact",
      title: "Here for your business.",
      call: "Call us",
      write: "Write to us",
      visit: "Address",
      hours: "Working hours",
      hoursVal: "Mon – Fri: 8am–4pm · Sat/Sun: closed",
      directions: "Directions",
    },
    footer: {
      tagline: "Wholesale distribution of consumer goods.",
      company: "Company",
      legal: "Legal details",
      quick: "Quick links",
      rights: "All rights reserved.",
      b2b: "Coming soon: B2B ordering portal.",
    },
    common: { required: "required", optional: "optional" },
    seo: {
      home: {
        title: "Kruška Distribucija DOO — Wholesale FMCG Distribution | Kruševac, Serbia",
        description:
          "Wholesale distributor of food, beverages, confectionery, snacks and consumer goods across Serbia. We supply markets, kiosks, HoReCa and gas stations. Request a quote.",
      },
      catalog: {
        title: "Catalogue 2026 — Kruška Distribucija | Chocolate, drinks, coffee, snacks",
        description:
          "Complete Kruška Distribucija range: Milka, Mars, Kinder, Ferrero, Nutella, Coca-Cola, Red Bull, Grand, Nescafé, Pringles, Orbit, Jack Daniel's and other leading brands. Wholesale catalogue 2026.",
      },
    },
  },
};
